import React, {Component} from "react";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {AppState} from "../../../RootReducer";
import {LoginStatus} from "../../../http/Types";
import {initDeposit, initStorePurchase} from "../../../payments/DepositActions";
import {CurrencyDefinition, PaymentMethod, Settings, UserInfo} from "../../../http/protocol";
import {DepositState} from "../../../payments/PaymentsReducer";
import "./styles/PaymentProviderButton.scss";
import {t} from "../../../i18n";
import ActiveItem from "./ActiveItem";
import Item from "./Item";
import {getActiveCurrency} from "../../../selectors/user-selectors";
import {fetchProviders, reset, selectGroup, selectMethod} from "../../../payments/PaymentsActions";
import {getActiveGroup} from "../../../selectors/payments-selectors";

interface State {
    clicked: boolean;
}

interface Props {
    loggedIn: boolean;
    deposit: DepositState;
    user?: UserInfo;
    selectMethod?: typeof selectMethod;
    selectGroup?: typeof selectGroup
    initDeposit? :() => void;
    initStorePurchase?: (bundleId?: number) => void;
    settings?: Settings;
    selectedBundleId?: number;
    fetchProviders? : () => void;
    reset? : typeof reset;
    activeSiteCurrency? : CurrencyDefinition;
    activeGroup? : string;
}

export class PaymentProviderButtonDeposit extends Component<Props, State>{
    constructor(props: Props){
        super(props);

        this.state = {
            clicked: false
        }
    }

    componentDidUpdate(prevProps: Props) {
        if (this.props.deposit !== prevProps.deposit) {
            if(this.props.deposit.activeMethod !== prevProps.deposit.activeMethod) {
                if (this.props.settings && this.props.settings.useStoreInsteadOfDeposit) {
                    if (this.props.deposit.activeMethod) {
                        this.props.initStorePurchase && this.props.initStorePurchase(this.props.selectedBundleId);
                    }
                }
            }
        }
    }



    handleClick = () => {
        this.setState({clicked: !this.state.clicked});
    }

    handleClickMethod = (method : PaymentMethod, group?: boolean)  => {
        this.setState({clicked: !this.state.clicked});
        if(this.props.activeSiteCurrency?.code) {
            if(group) {
                this.props.reset?.(this.props.activeSiteCurrency?.code);
                this.props.selectGroup?.(method.group);

            } else {
                this.props.selectMethod && this.props.selectMethod(method,this.props.activeSiteCurrency?.code);

            }
        }
    }

    render() {
        const {deposit} = this.props;


        if(!deposit || !this.props.activeSiteCurrency?.code || !deposit.methods || !deposit.methods[this.props.activeSiteCurrency.code]) {
            return <span/>
        }
        let renderedGroups : string[] = [];
        return (
            <React.Fragment>
            {
                deposit.methods[this.props.activeSiteCurrency?.code].filter(m => m.depositEnabled).length > 1 && deposit.activeMethod
                    ? (
                        <div className={"dropdown"}>
                            <span className={"title"}>
                                {t("payments.paymentMethod")}
                            </span>
                            <a className={"btn btn-secondary-popup small"} onClick={()=> this.props.reset?.(this.props.activeSiteCurrency?.code)}>{t("payments.show-all")}</a>
                            <div onClick={this.handleClick} className={this.state.clicked ? `${"dropbtn"} ${"clicked"}` : "dropbtn"}>
                                {
                                    deposit.activeMethod&& (
                                        <ActiveItem clicked={this.state.clicked} method={deposit.activeMethod}/>
                                    )
                                }
                            </div>
                            <div className={this.state.clicked ? `${"dropdown-content"} ${"clicked"}` : "dropdown-content"}>
                                {
                                    deposit.methods[this.props.activeSiteCurrency?.code].filter(m => m.depositEnabled).map((m : PaymentMethod, index: number) => {
                                        if(m.group && renderedGroups.find(g => g === m.group)) {
                                            return false;
                                        } else if(m.group && m.group.length > 0) {
                                            renderedGroups.push(m.group);
                                        }
                                        return <Item key={index} method={m} onClick={this.handleClickMethod}/>
                                    })
                                }
                            </div>
                        </div>
                    )
                    : null
            }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state : AppState) => {
    let {user, payments, settings, store} = state;
    return {
        loggedIn : LoginStatus.LOGGED_IN == user.status,
        user: user.user,
        deposit : payments.deposit,
        settings: settings.settings,
        selectedBundleId: store.selectedBundleId,
        activeSiteCurrency : getActiveCurrency(state),
        activeGroup : getActiveGroup(state)
    }
}


const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        selectMethod : (method : PaymentMethod, currencyCode : string) => dispatch<any>(selectMethod(method,currencyCode)),
        initDeposit : ()=>dispatch(initDeposit() as any),
        initStorePurchase : (bundleId?: number)=>dispatch(initStorePurchase(bundleId) as any),
        fetchProviders : () => dispatch(fetchProviders() as any),
        reset : (code ? : string) => dispatch(reset(code) as any),
        selectGroup : (group : string) => dispatch(selectGroup(group) as any)

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentProviderButtonDeposit as any);